/**
 * TransparencyModal — modal genérico bilingüe usado por los botones
 * "Transparencia" sobre las tarjetas de Plan Free / Plan Premium en la
 * página /planes-y-beneficios.
 *
 * Cierra: botón ✕ del header, click en el backdrop, tecla Escape.
 * Accesible: role="dialog", aria-modal, focus en el contenedor.
 */
import { useEffect, useRef } from 'react';
import { X } from 'lucide-react';
import './TransparencyModal.css';

export default function TransparencyModal({ title, children, onClose, testId }) {
  const modalRef = useRef(null);

  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    // Auto-focus para accesibilidad.
    if (modalRef.current) {
      try { modalRef.current.focus(); } catch { /* ignore */ }
    }
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) onClose();
  };

  return (
    <div
      className="transparency-modal-backdrop"
      onClick={handleBackdropClick}
      data-testid={testId ? `${testId}-backdrop` : 'transparency-modal-backdrop'}
    >
      <div
        ref={modalRef}
        className="transparency-modal"
        role="dialog"
        aria-modal="true"
        aria-label={title}
        tabIndex={-1}
        data-testid={testId || 'transparency-modal'}
      >
        <div className="transparency-modal-header">
          <h2>{title}</h2>
          <button
            type="button"
            className="transparency-modal-close"
            onClick={onClose}
            aria-label="Cerrar"
            data-testid={testId ? `${testId}-close` : 'transparency-modal-close'}
          >
            <X className="w-5 h-5" aria-hidden="true" />
          </button>
        </div>
        <div className="transparency-modal-body">
          {children}
        </div>
      </div>
    </div>
  );
}
